import React from 'react';
import { Box, RowBox, Text, Span } from 'styles';
import { Icon, Button } from 'components';
import * as S from './FooterStyle';
import NSurveyPDF from '../../assets/docs/N-Survey.pdf';

export function Footer({ sectionRefs }) {
  const scrollToSection = (section) => {
    sectionRefs.current[section].scrollIntoView({ behavior: 'smooth' });
  };

  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = NSurveyPDF;
    link.download = 'N-Survey 소개서.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };

  return (
    <S.Footer>
      <Box $backgroundColor="strong" $padding="80px 40px" $mPadding="40px 20px">
        <Box $width="fit-content" $margin="auto">
          <Text $type="b72" $mType="28" $textAlign="center" $color="white">
            꼭 맞는 설문,
            <br /><Span $type="b72" $mType="b28" $color="primary900">N-Survey</Span>
            로 만나보세요!
          </Text>
          <Text $type="m32" $mType="m16" $padding="40px 0" $mPadding="20px 0" $color="white" $textAlign="center">
            설문 의뢰부터 결과 분석까지, 더 스마트한 의사결정을 위한 첫 걸음을 시작하세요.
          </Text>
          <RowBox $gap={24} $mGap={8} $width="fit-content" $margin="auto">
            <Button $type="cancel" $mPadding="17px 24px" onClick={downloadPDF}>
              <Text $type="b18" $mType="b14">소개서 다운로드</Text>
            </Button>
            <Button $type="cancel" $mPadding="17px 24px" onClick={() => sectionRefs.current['request'].scrollIntoView({ behavior: 'smooth' })}>
              <RowBox $gap={8} $alignItems="center">
                <Text $type="b18" $mType="b14">의뢰 신청하기</Text>
                <Icon name="arrowRight" />
                </RowBox>
            </Button>
          </RowBox>
        </Box>
      </Box>
      <Box $maxWidth={1600} $padding="40px" $mPadding="20px" $margin="auto">
        <Icon name="LogoText" />
        <RowBox $gap={32} $mGap={4} $mFlexDirection="column" $mAlignItems="center" $justifyContent="center" $padding="16px 0 8px">
          <RowBox $gap={8}>
            <Text $color="supportive" $type="m12" $whiteSpace="pre">
              상호명
            </Text>
            <Text $color="assistive" $type="m12">
              나모웹비즈 주식회사
            </Text>
          </RowBox>
          <RowBox $gap={8} $marginTop={2}>
            <Text $color="supportive" $type="m12" $whiteSpace="pre">
              사업자등록번호
            </Text>
            <Text $color="assistive" $type="m12">
              215-87-91517
            </Text>
          </RowBox>
          <RowBox $gap={8} $marginTop={2}>
            <Text $color="supportive" $type="m12" $whiteSpace="pre">
              대표
            </Text>
            <Text $color="assistive" $type="m12">
              진병각
            </Text>
          </RowBox>
        </RowBox>
        <RowBox $gap={8} $justifyContent="center" $marginBottom={16}>
          <Text $color="supportive" $type="m12" $whiteSpace="pre">
            주소
          </Text>
          <Text $color="assistive" $type="m12">
            서울특별시 송파구 법원로11길 11 B동 1403호
          </Text>
        </RowBox>
        <Text $color="gray400" $type="m12">
          Copyright Namowebiz,Inc. All Rights Reserved.
        </Text>
      </Box>
    </S.Footer>
  );
}
